import { Input } from 'src/components/Input';
import { SkillCard } from './SkillCard';
import {
  CallBackLaterConfig,
  INITIAL_CALL_TIME_CONFIRMATION_MESSAGE,
} from './constants';

export function CallBackLaterSkill({
  config,
  onConfigChange,
}: {
  config: CallBackLaterConfig;
  onConfigChange?: (config: CallBackLaterConfig) => void;
}) {
  return (
    <SkillCard description="Set the messages the agent uses for the call back later skill.">
      <div className="mb-4">
        <Input
          label="Callback Confirmation (End Call)"
          placeholder={INITIAL_CALL_TIME_CONFIRMATION_MESSAGE}
          value={config.end_call_message ?? ''}
          onChange={(e) =>
            onConfigChange?.({
              ...config,
              end_call_message: e.target.value,
            })
          }
          required
        />
      </div>
      <div className="mb-4">
        <Input
          label="Callback Initial Message"
          placeholder="Hi {first_name}, this is {company_name} calling you back. Is now a good time to talk?"
          value={config.callback_initial_message ?? ''}
          onChange={(e) =>
            onConfigChange?.({
              ...config,
              callback_initial_message: e.target.value,
            })
          }
          required
        />
      </div>
    </SkillCard>
  );
}
